import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {of, tap} from 'rxjs';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {Store} from '@ngrx/store';

import {Router} from "@angular/router";
import {ToastMessageOptions, MessageService} from "primeng/api";
import {ErrorMessageTypes, GetMessage} from "../../../global-config/utils/toast-messages.utils";

import {AppState} from "../../../shared/state/app.state";
import {
  disableUser, disableUserFailure, disableUserSuccess,
  loadRoleDropDownData,
  loadRoleDropDownDataFailure,
  loadRoleDropDownDataSuccess,
  loadUsers,
  loadUsersFailure,
  loadUsersSuccess,
  updateUsersRole,
  updateUsersRoleFailure,
  updateUsersRoleSuccess
} from "./user.action";
import {UserService} from "../../data-access/user.service";
import {RoleService} from "../../data-access/role.service";


@Injectable()
export class UserEffects {

  loadUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUsers),
      switchMap(() =>
        this.userService.getUsers()
          .pipe(
            map((users) => loadUsersSuccess({users: users})),
            catchError((error) => of(loadUsersFailure({ error: GetMessage('LoadFailure', 'Users') })))
          )
      )
    )
  );

  loadRoleDropDownData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadRoleDropDownData),
      switchMap(() =>
        this.roleService.getNames()
          .pipe(
            map((roles) => loadRoleDropDownDataSuccess({roles: roles})),
            catchError((error) => of(loadRoleDropDownDataFailure({ error: GetMessage('LoadFailure', 'Role') })))
          )
      )
    )
  );

  updateUserRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateUsersRole),
      switchMap((action) =>
        this.userService.updateUserRoles(action.userId, action.roleId)
          .pipe(
            map((users) => updateUsersRoleSuccess({users: users, successMessage: GetMessage('ModifySuccess', "User's Role")})),
            catchError((error) => of(updateUsersRoleFailure({ error: GetMessage('ModifyFailure', "User's Role") })))
          )
      )
    )
  );

  disableUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(disableUser),
      switchMap((action) =>
        this.userService.disableUser(action.userId)
          .pipe(
            map((user) => disableUserSuccess({userId: action.userId, successMessage: GetMessage('RemoveSuccess', "User")})),
            catchError((error) => {
              console.log('HELLLO?????, ', error)
              return of(disableUserFailure({error: GetMessage('RemoveFailure', "User")}
            ))
            })

          )
      )
    )
    );

  toastSuccessMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        updateUsersRoleSuccess,
        disableUserSuccess

      ),
      tap(({ successMessage }) => {
          return this.messageService.add({
            severity: 'success',
            summary: successMessage,
          } as ToastMessageOptions)
        }
      )
    ),
    { dispatch: false }
  );

  toastErrorMessages$ = createEffect(() =>
      this.actions$.pipe(
        ofType(
          updateUsersRoleFailure,
          loadUsersFailure,
          disableUserFailure
        ),
        tap(({ error }) => {
            return this.messageService.add({
              severity: 'error',
              summary: error,
            } as ToastMessageOptions)
          }
        )
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private router: Router,
    private messageService: MessageService,
    private userService: UserService,
    private roleService: RoleService,
  ) {}
}

